import React, { useMemo } from "react";
import cx from "classnames";
export const EditorContentBackground = ({ backgroundColor, backgroundImage, backgroundSize, filter, overlay, className, }) => {
    const classes = cx("editor-content-background", className);
    const style = useMemo(() => {
        return {
            backgroundColor,
            "--editor-content-background-image": backgroundImage,
            "--editor-content-background-size": backgroundSize,
            "--editor-content-background-filter": filter,
            "--editor-content-background-overlay-color": overlay === null || overlay === void 0 ? void 0 : overlay.color,
            "--editor-content-background-overlay-opacity": overlay === null || overlay === void 0 ? void 0 : overlay.opacity,
        };
    }, [
        backgroundColor,
        backgroundImage,
        backgroundSize,
        filter,
        overlay === null || overlay === void 0 ? void 0 : overlay.color,
        overlay === null || overlay === void 0 ? void 0 : overlay.opacity,
    ]);
    return React.createElement("div", { className: classes, style: style });
};
